import { connect } from 'react-redux'
import Home from './index'
import { setSafariAutoFillInfoAction, LogOutAction } from '../common.actions'
import { getEntitlementListAction } from './actions/entitlement.action'

const mapStateToProps = state => ({
	userInfo: state.commonReducer.userInfo,
	entitlementInfo: state.commonReducer.entitlementInfo
})

const mapDispatchToProps = (dispatch) => ({
	setSafariAutoFillInfo: (flag) => {
		setSafariAutoFillInfoAction(dispatch, flag)
	},
	getEntitlementList: (accountNo, cb) => {
		getEntitlementListAction(accountNo, dispatch, cb);
	},
	logout: () => {
		LogOutAction(dispatch)
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
